import _extends from "@babel/runtime/helpers/esm/extends";
import React from 'react';
import { Prism } from 'react-syntax-highlighter';
import merge from 'lodash.merge';
import { getLanguage } from './syntax-highlighter';
import { jsx as ___EmotionJSX } from "@emotion/core";
export var pre = function pre(props) {
  return props.children;
};
export var createCode = function createCode(opts) {
  if (opts === void 0) {
    opts = {};
  }

  return function (props) {
    var language = getLanguage(props.className);
    return ___EmotionJSX(Prism, _extends({}, opts, {
      language: language
    }, props));
  };
};
export default (function (theme) {
  return merge(theme, {
    components: {
      pre: pre,
      code: createCode(theme.prism)
    }
  });
});